<template>
    <div class="container">
        <div class="modal fade" v-bind:id="id + '_datePickerModal'" tabindex="-1" role="dialog" v-bind:aria-labelledby="id" aria-hidden="true">
            <div class="modal-dialog date-picker-modal" role="document">
                <div class="modal-content date-picker-modal-content">
                    <div class="modal-body date-picker-modal-body">
                        <DatePicker class="form-control scheduled-on-input" id="scheduledOnDate" v-model="modalValue" v-bind:mode="mode"></DatePicker>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="handleCancelClicked()">{{ $t("ui.date_selector.cancel_button") }}</button>
                        <button type="button" class="btn btn-primary" v-on:click="handleSelectClicked()">{{ $t("ui.date_selector.select_button") }}</button>
                    </div>
                </div>
            </div>
        </div>

        <span class="value">{{ dateValue }}</span>
        <a class="btn btn-link btn-sm" href="#" v-on:click="handleSelectDateClicked()">{{ $t("ui.date_selector.select_button") }}</a>
        <a class="btn btn-link btn-sm" href="#" v-on:click="handleClearClicked()">{{ $t("ui.date_selector.clear_button") }}</a>
    </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import * as moment from 'moment';

export default {
    name: "DateSelector",

    components: {
        DatePicker
    },

    props: {
        id: String,
        value: String,        
        mode: {
            type: String,
            default: "date"
        }
    },

    computed: {
        dateValue: function() {
            return this.selectedValue == null ? this.$t("ui.date_selector.no_date_selected") : moment(new Date(this.selectedValue)).format("YYYY-MM-DD hh:mm")
        }
    },

    data() {
        return {
            datePickerModal: null,
            modalValue: null,
            selectedValue: null
        }
    },

    methods: {
        handleSelectDateClicked() {
            if (this.modalValue == null) {
                this.modalValue = new Date();
            }
            this.datePickerModal.show();
        },

        handleClearClicked() {
            this.selectedValue = null;
            this.modalValue = null;
            this.$emit("input", null);
        },

        handleSelectClicked() {
            this.selectedValue = this.modalValue;
            this.$emit("input", this.selectedValue);
            this.datePickerModal.hide();
        },

        handleCancelClicked() {
            this.datePickerModal.hide();
        }
    },

    mounted() {
        this.datePickerModal = new this.bootstrap.Modal(document.getElementById(this.id + '_datePickerModal'));
        this.modalValue = this.value;
        this.selectedValue = this.value;
    }
}
</script>

<style scoped>
.value {
    margin-right: 16px;
}

.date-picker-modal {
    max-width: 360px;
}

.date-picker-modal-body {
    text-align: center;
}

.date-picker-modal-content {
    margin-top: 48px;
}
</style>